import { getLocalStorage, removeLocalStorage, setLocalStorage } from '@b2ag/utils/src/localStorage'

const CHECKOUT_TO_CANCEL_ID_LOCAL_STORAGE_KEY = 'checkoutToCancelId'

export function getCheckoutToCancelId(): string | null {
  return getLocalStorage(CHECKOUT_TO_CANCEL_ID_LOCAL_STORAGE_KEY)
}

export function setCheckoutToCancelId(checkoutId: string) {
  setLocalStorage(CHECKOUT_TO_CANCEL_ID_LOCAL_STORAGE_KEY, checkoutId)
}

export function removeCheckoutToCancelId() {
  removeLocalStorage(CHECKOUT_TO_CANCEL_ID_LOCAL_STORAGE_KEY)
}
